import React, { useEffect, useRef } from "react";
import styles from './MapOutput.module.css';
import {ReactComponent as LocationIconActive} from './../../../../assets/svg/location-active-icon.svg';
import mapboxgl from "!mapbox-gl"; // eslint-disable-line
mapboxgl.accessToken =
    "pk.eyJ1IjoicmFtaW5yNzciLCJhIjoiY2s4YW40eDh1MDNmajNtcWZiejJ1MWk2biJ9.c4EP7MYCOIRsC56LLM7qrA";
// mapboxgl.setRTLTextPlugin(
//   "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
//   null,
//   true
// );

const MapOutput = (props) => {
    const { lng, lat } = props;

    const zoom = 14;

    const map_container_ref = useRef(null);

    useEffect(() => {
        const map = new mapboxgl.Map({
            container: map_container_ref.current,
            style: "mapbox://styles/mapbox/streets-v11",
            center: [lng, lat],
            zoom: zoom,
        });
        const el = document.createElement("div");
        const elImg = document.createElement("img");
        elImg.src = LocationIconActive 
        elImg.className = styles.LocationIcon;
        el.className = styles.CustomMarker;
        el.appendChild(elImg);
        new mapboxgl.Marker(elImg).setLngLat([lng, lat]).addTo(map);
        // eslint-disable-next-line
    }, []);

    return (
        <div className="height-100per">
            <div
                id="markero"
                ref={map_container_ref}
                className="mapContainer"
            />
        </div>
    );
};

export default MapOutput;
